import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { add } from "../../../store/reducers/todosReducer";
import GCalendar from "../../common/calendar/Calendar";
import GenericModal from "../../common/modals/GenericModal";
import { editDetails } from "../../../store/reducers/authReducer";

const DeleteTables = ({ init }) => {
  const { user } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    let arr = [...user.tablesArray];
    arr = arr.splice(0, arr.length - data.tables);
    setLoading(true);
    dispatch(editDetails({ tablesArray: arr })).then((res) => {
      setLoading(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>כמות שולחנות למחיקה</Label>
        <Input
          type="number"
          {...register("tables", {
            required: true,
            min: 1,
            max: 150,
          })}
        />
        {CFV(`tables`, `מספר בין 1 ל 150`, errors)}

        <FlexRowBetween style={{ marginTop: "30px" }}>
          <Button style={{ width: "100%" }}>שמירה</Button>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default DeleteTables;
